<template>
    <div :class="containerClassName">
        <slot name="label-container">
            <div :class="labelContainerClassName">
                <slot name="before-label"></slot>
                <slot name="label">
                    <v-label v-if="getLabel()" :id="id" :label="getLabel()" :helper="helper" :class-name="labelClassName"></v-label>
                </slot>
                <slot name="after-label"></slot>
            </div>
        </slot>
        <div :class="inputContainerClassName">
            <slot></slot>
            <slot name="after-input"></slot>
            <p class="text-gray-500 font-thin text-sm mt-2" v-if="withCounter" :class="{'text-red': maxLength && model && model.length > maxLength}">
                <template v-if="model && model.length">{{ model.length }}</template><template v-else>0</template><span v-if="maxLength">/{{maxLength}}</span>
                characters
            </p>
            <v-error :form="form" :input-name="inputName" v-if="displayError"></v-error>
        </div>
    </div>
</template>

<script>

    import FormLabel from './Label';
    import FormError from './Error';
    import mixin from './mixin';

    export default {
        components: {
            'v-label': FormLabel,
            'v-error': FormError
        },
        mixins: [mixin]
    }
</script>
